import React from 'react';
import { connect } from 'react-redux'

import { Row, Col, Divider, List, Spin, Dropdown, Button, Empty } from 'antd';
import { CalendarOutlined, DownCircleOutlined, DownloadOutlined, EditOutlined, FileOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom/cjs/react-router-dom';

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={
                table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)
              }
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      title={<>{(row.gtk_gelar_depan ? row.gtk_gelar_depan + " " : "") + (row.gtk_nama_lengkap ? row.gtk_nama_lengkap : "-") + (row.gtk_gelar_belakang ? " " + row.gtk_gelar_belakang : "")}<br />NUPTK: {row.nuptk}</>}
                      description={
                        <small>
                          Jadwal Supervisi: {row.tgl_evaluasi ? row.tgl_evaluasi : "-"}<br />
                          Penilai: {(row.penilai_gelar_depan ? row.penilai_gelar_depan + " " : "") + (row.penilai_nama_lengkap ? row.penilai_nama_lengkap : "-") + (row.penilai_gelar_belakang ? " " + row.penilai_gelar_belakang : "")}<br />
                          Nilai PKG: {row.nilai_akhir ? row.nilai_akhir : "-"}<br />
                          File instrumen Evaluasi: <a target="_blank" rel="noopener noreferrer" href={row.main_path + row.file || ""} style={{ fontSize: 11 }}>Download <DownloadOutlined /></a>
                        </small>
                      }
                    />
                    <div>
                      {(!action.detail && !action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.detail ? [{
    key: 0,
    label: <Link to={"/supervisi/pkg/" + row.id}><FileOutlined /> Berkas</Link>
  }] : []), ...(action.update && !row.nilai_akhir ? [{
    key: 1,
    icon: <CalendarOutlined />,
    label: "Atur Jadwal",
    onClick: this.props.modalJadwalEvaluasi.bind(this, true, row)
  }] : []), ...(action.update && row.tgl_evaluasi ? [{
    key: 2,
    icon: <EditOutlined />,
    label: "Nilai Hasil Evaluasi",
    onClick: this.props.modalNilaiEvaluasi.bind(this, true, row)
  }] : [])]
}}>
                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                      </Dropdown>)}
                    </div>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Mobile);
